/**
 * mobile-menu-drawer.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import AnimatedSwitch from "routing/animated-switch";
import FeatureBox from 'components/feature-box';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    height: '100%',
    width: theme.size.menuDrawer.width,
    minWidth: theme.size.menuDrawer.minWidth,
    maxWidth: theme.size.menuDrawer.maxWidth,
    margin: '0 auto',
    [theme.breakpoints.down(theme.size.menuDrawer.minWidth)]: {
      minWidth: '100%',
      maxWidth: '100%',
      width: 'auto',
    }
  },
}));

export default function MobileMenuDrawer(props) {
  const {
    routes,
    drawerState,
  } = props;
  const classes = useStyles();


  const processRoutes = (routes) => {
    let newRoutes = routes.map(route => {
      return {
        path: route.path,
        children: (
          <route.component {...props} />
        )
      };
    });

    return newRoutes;
  }


  return (
    <>
      <div
        data-testid='mobile-drawer'
        className={classes.root}
      >
        <FeatureBox loading={drawerState.loading.content.get()}>
          <AnimatedSwitch
            id='mobile-drawer-router'
            routes={processRoutes(routes)}
          />
        </FeatureBox>
      </div>
    </>
  );
}